// Automated runs use Cypress
// Cypress adds a global object to the window object.
// We can use that to "detect" if a client is automatically onboarded

function isAutomatedRun() {
	return window.Cypress !== undefined;
}

export default isAutomatedRun;
